























import {Component, Mixins} from 'vue-property-decorator'
import ModalBaseBody from '../ModalBaseBody.vue'
import ContactPicker from '@/components/contact/ContactPicker.vue'
import {IContact} from '@/entities'
import modalItemContactMixin from "@/mixins/modal/modalItemContactMixin";

@Component({
  components: {
    ModalBaseBody,
    ContactPicker
  }
})
export default class ModalConsultationCheck extends Mixins(modalItemContactMixin) {

  protected getHandlers(): { [key: string]: Function } {
    let self = this;
    return {
      next: self.submitPromise
    }
  }

  protected actionPromise(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      return this.$storage.actions.setRequestServiceContact({
        ...this.getActionData(),
        config: {
          params: {
            status: 'waiting'
          }
        }
      })
        .then((res: IContact) => {
          this.subject.status = 'waiting';
          this.subject.contact = res;
          resolve();
        })
        .catch(reject);
    });
  }

}
